export class Client {
    public firstName!: string;
    public lastName!: string;
    public email!: string;
    public phoneNumber!: string;
    public enableEmailMarketing!: boolean;
    public enableTextMarketing!: boolean;
    public enableTextNotifications!: boolean;
    public address1?: string;
    public address2?: string;
    public city?: string;
    public state?: string;
    public zipCode?: string;
    public onlineID?: string;

    public constructor(init?: Partial<Client>) {
        Object.assign(this, init);
    }
}
